module.exports = __webpack_public_path__ + "img/toggleButton.f67f779e.svg";